import type { RequestConfig } from '@customTypes/index';
import type { HousingDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetClubProfileHousingRequest = {
  clubId: string;
};

export type GetClubProfileHousingParams =
  RequestConfig<GetClubProfileHousingRequest>;

export const getClubProfileHousing = async ({
  params,
  config
}: GetClubProfileHousingParams) =>
  api.get<HousingDto>(`/api/ClubProfile/housing/${params.clubId}`, config);
